import React, { useRef } from 'react'
import { easing } from 'maath'
import { useFrame } from '@react-three/fiber'
import { AccumulativeShadows,RandomizedLight } from '@react-three/drei'

const BackDrop = () => {

  const shadows = useRef();

  return (
    <AccumulativeShadows
      ref={shadows}
      temporal
      frames={60}
      alphaTest={0.30}
      scale={10}
      rotation={[Math.PI/2,0,0]}
      position={[0,0,-0.40]}  
    >
      <RandomizedLight
        amount={4}
        radius={2}
        intensity={0.55}
        ambient={0.25}
        position={[5,5,-20]} 
        />
      <RandomizedLight
        amount={10}
        radius={5}
        intensity={0.55}
        ambient={0.7}
        position={[5,5,-10]} 
      />
    </AccumulativeShadows>
  )
}

export default BackDrop

// import React, { useRef } from 'react'
// import { easing } from 'maath'
// import { useFrame } from '@react-three/fiber'
// import { AccumulativeShadows, RandomizedLight } from '@react-three/drei';

// const Backdrop = () => {
//   const shadows = useRef();

//   return (
//     <AccumulativeShadows
//       ref={shadows}
//       temporal
//       frames={60}
//       alphaTest={0.30}
//       scae={10}
//       rotation={[Math.PI / 2, 0, 0]}
//       position={[0, 0, -0.40]}
//     >
//       <RandomizedLight 
//         amount={4}
//         radius={9}
//         intensity={0.55}
//         ambient={0.25}
//         position={[5, 5, -10]}
//       />
//       <RandomizedLight 
//         amount={4}
//         radius={5}
//         intensity={0.25}
//         ambient={0.55}
//         position={[-5, 5, -9]}
//       />
//     </AccumulativeShadows>
//   )
// }

// export default Backdrop